import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import { drawerReducer } from "./reducers/drawer";
import { productsReducer } from "./reducers/productsReducer";
import { productDetailReducer } from "./reducers/productDetail";
import { cartReducer } from "./reducers/cartReducer";
import { searchReducer } from "./reducers/search";
import { ordersReducer } from "./reducers/ordersReducer";
import { productReviewsReducer } from "./reducers/productReviews";
import { adminReducer, usersReducer } from "./reducers/usersReducer";
import { promoCodeReducer } from "./reducers/promoReducer";
import { categoryReducer } from "./reducers/categoryReducer";
import { courierReducer } from "./reducers/courierapisReducer";
import { wishlistReducer } from "./reducers/wishlistReducer";
import { wishlistDrawerReducer } from "./reducers/wishlistDrawer";

const cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];

const rootReducer = combineReducers({
  admin: adminReducer,
  drawer: drawerReducer,
  products: productsReducer,
  allproducts: productsReducer,

  orders: ordersReducer,
  allorders: ordersReducer,

  users: usersReducer,
  allusers: usersReducer,

  productDetail: productDetailReducer,
  productReview: productReviewsReducer,

  cart: cartReducer,
  search: searchReducer,

  promoCodes: promoCodeReducer, // promo codes + usage analytics

  category: categoryReducer,
  cities: courierReducer,

  wishlist: wishlistReducer,
  wishlistDrawer: wishlistDrawerReducer,
});

const preloadedState = {
  cart: { cartItems },
  wishlist: { wishlistProducts: [] },
  promoCodes: {
    promoCodes: [],
    promoUsage: null,
    promoBanners: [],  // <-- new state for promotional banners
  },
};

const store = configureStore({
  reducer: rootReducer,
  preloadedState,
  devTools: process.env.NODE_ENV !== "production",
});

export default store;